import {Injectable, Injector, inject} from "@angular/core";
import {EntityData, field, SearchModel} from "@fedelta-pos/data-client";

export class SellableSizesData extends EntityData<SellableSizesData> {
    @field groupId: number;
    @field groupName: string;
    @field externalName: string;
    @field externalSizeName: string;
    @field sellableSizeGroupId: number;
    @field standardSellableId: number;
    @field sellableId: number;
    @field sellableSizeId: number;
    @field sizeLabel: string;
    @field sizeAbbreviation: string;
}

@Injectable()
export class SellableSizesSearchModel extends SearchModel<SellableSizesData> {
    constructor() {
        console.log("--- SellableSizesSearchModel");
        super(inject(Injector), SellableSizesData);
    }
}
